import { CollectionViewList } from "../../models";
import { UserToken } from "../../types/token/token";
import { Rule } from "../../utils/userPermissionsOnItem/rulesHelpers";


interface SearchResult {
    Value: {
        Source: Document
    }
}

interface SearchResponse {
    data: SearchResult[]
    count: number
}

interface Options {
    abortController?: AbortController | null
}

type SearchItemResponse = Document | null

const initSearchResponse: SearchResponse = {
    data: [],
    count: 0
}

interface SearchOptions {
    abortController?: AbortController | null
    returnFullData?: boolean
}


export default class CollectionListRulesService {
    // constructor(token) {
    //     this.#token = token
        
    //     this.backendUrl = process.env.API_SERVER
    
    //     this.backendUrl = process.env.API_SERVER
    //     this.collectionListRulesUrl = process.env.API_SERVER + "/collectionListRules"
    // }

    #token: UserToken = null
    #url: string = ''
    #collectionListRulesUrl = "/collectionListRules"
    constructor(token: UserToken) {
        this.#token = token;
    }

    getHeaders() {
        return {
            'Authorization': 'Bearer ' + this.#token
        };
    }

    getHeader() {
        return {
            'Authorization': 'Bearer ' + this.#token
        };
    }

    postHeaders() {
        return new Headers({
            'Authorization': 'Bearer ' + this.#token,
            'Content-Type': 'application/json'
        });
    }

    setToken = (token: UserToken, url?: string) => {
        this.#token = token;
        this.#url = url ?? "";
    }

    getToken() {
        return this.#token;
    }

    createRule(list: CollectionViewList, rule: any) {
        try {
        if (rule.ruleDataType) {
            const address = `${this.#collectionListRulesUrl}/newLaneRule`
            return fetch(address,
            {
                method: 'POST',
                body: JSON.stringify({
                    list,
                    rule
                }),
                headers: this.postHeaders()
            })
            .then(res => res.json());
        }     }
        catch(err) {
            //@ts-ignore
            // if (err.name == 'AbortError') {
            //     return { val: '', isAborted: true }
            // }
            // return { val: '', isAborted: false }
        }
        
    }

    async getRuleData(ruleId: any, listId: any) {
        // if (ruleId && listId) {
           
        //     const params = `ruleId=${encodeURIComponent(ruleId)}&listId=${encodeURIComponent(listId)}`;
        //     const address = `${this.#collectionListRulesUrl}/getRuleData?${params}`
        //     return fetch(address,
        //     {
        //         method: 'GET',
        //         headers: this.getHeader()
        //     });
        // }

        try {
            // const params = `ruleId=${encodeURIComponent(ruleId)}&listId=${encodeURIComponent(listId)}`;
            // const address = `${this.#collectionListRulesUrl}/getRuleData?${params}`

            
            // const res = await fetch(address, {
            //     method: 'GET',
            //     headers: this.getHeaders(),
            //     signal: options?.abortController?.signal
            // })
            
            // if(!res) return { val: '', isAborted: false }
           
            // const resT = res.json().then(r => r)
            // console.log('resT',resT)
            // return { val: resT, isAborted: false }

            
            const params = `ruleId=${encodeURIComponent(ruleId)}&listId=${encodeURIComponent(listId)}`;
            const address = `${this.#collectionListRulesUrl}/getRuleData?${params}`
            return fetch(address,
            {
                method: 'GET',
                headers: this.getHeader()
            });
        }
        catch(err) {
            //@ts-ignore
            // if (err.name == 'AbortError') {
            //     return { val: '', isAborted: true }
            // }
            // return { val: '', isAborted: false }
        }
    }

    // async groupMailingService(collectionId: number, enableEmail: boolean, options: GetKanbanOptions): Promise<{val: string, isAborted: boolean}> {
    //     try {
    //         const address = `${this.#url}/collections/setupmail?collectionId=${collectionId}&enableEmail=${enableEmail}`
    //         const res = await fetch(address, {
    //             method: 'GET',
    //             headers: this.getHeaders(),
    //             signal: options?.abortController?.signal
    //         })
            
    //         if(!res) return { val: '', isAborted: false }
    //         const res1: {result: string, status: boolean} = await res.json()
            
    //         return { val: res1.result, isAborted: false }
    //     }
    //     catch(err) {
    //         //@ts-ignore
    //         if (err.name == 'AbortError') {
    //             return { val: '', isAborted: true }
    //         }
    //         return { val: '', isAborted: false }
    //     }
    // }
    

    deleteRule(listId: any, ruleId: any){
        if (listId && ruleId) {
            const address = `${this.#url}/collectionListRules/delete?listId=${listId}&ruleId=${ruleId}`
            return fetch( address, {
                method: 'DELETE',
                headers: this.postHeaders()
            });
        }
    }
}